'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  justify-content: left;\n  position: relative;\n  height: auto;\n  ', '\n\n  input {\n    display:none;\n  }\n\n  .slider {\n    position: absolute;\n    cursor: pointer;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: transparent;\n    -webkit-transition: .4s;\n    transition: .4s;\n    border: 1px solid ', ';\n    width: 48px;\n    height: 30px;\n  }\n\n  .slider:before {\n    position: absolute;\n    content: "";\n    height: 21px;\n    width: 21px;\n    left: 4px;\n    bottom: 3px;\n    background-color: ', ';\n    -webkit-transition: .4s;\n    transition: .4s;\n  }\n\n  input:checked + .slider {\n    background-color: transparent;\n  }\n\n  input:focus + .slider {\n    box-shadow: 0 0 1px #2196F3;\n  }\n\n  input:checked + .slider:before {\n    -webkit-transform: translateX(17px);\n    -ms-transform: translateX(17px);\n    transform: translateX(17px);\n  }\n\n  .slider.round {\n    border-radius: 25px;\n  }\n\n  .slider.round:before {\n    border-radius: 50%;\n  }\n'], ['\n  display: flex;\n  justify-content: left;\n  position: relative;\n  height: auto;\n  ', '\n\n  input {\n    display:none;\n  }\n\n  .slider {\n    position: absolute;\n    cursor: pointer;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: transparent;\n    -webkit-transition: .4s;\n    transition: .4s;\n    border: 1px solid ', ';\n    width: 48px;\n    height: 30px;\n  }\n\n  .slider:before {\n    position: absolute;\n    content: "";\n    height: 21px;\n    width: 21px;\n    left: 4px;\n    bottom: 3px;\n    background-color: ', ';\n    -webkit-transition: .4s;\n    transition: .4s;\n  }\n\n  input:checked + .slider {\n    background-color: transparent;\n  }\n\n  input:focus + .slider {\n    box-shadow: 0 0 1px #2196F3;\n  }\n\n  input:checked + .slider:before {\n    -webkit-transform: translateX(17px);\n    -ms-transform: translateX(17px);\n    transform: translateX(17px);\n  }\n\n  .slider.round {\n    border-radius: 25px;\n  }\n\n  .slider.round:before {\n    border-radius: 50%;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  line-height: 28px;\n  margin-right: 10px;\n  color: ', ';\n  font-weight: ', ';\n'], ['\n  line-height: 28px;\n  margin-right: 10px;\n  color: ', ';\n  font-weight: ', ';\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  line-height: 28px;\n  margin-left: 10px;\n  color: ', ';\n  font-weight: ', ';\n'], ['\n  line-height: 28px;\n  margin-left: 10px;\n  color: ', ';\n  font-weight: ', ';\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  width: 50px;\n  margin-bottom: 18px;\n  font-weight: 700;\n  overflow: visible;\n  height: auto;\n  position: relative;\n'], ['\n  width: 50px;\n  margin-bottom: 18px;\n  font-weight: 700;\n  overflow: visible;\n  height: auto;\n  position: relative;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _color = require('../color');

var _color2 = _interopRequireDefault(_color);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ToggleContainer = _styledComponents2.default.div(_templateObject, function (props) {
  return props.border ? 'padding: 15px; border: 1px solid ' + _color2.default.grey_accent_1 + '; border-radius: 5px; box-shadow: 0 2px 4px 0 rgba(0,0,0,0.1);' : '';
}, _color2.default.blue_accent, _color2.default.blue_accent);

var LeftLabel = _styledComponents2.default.label(_templateObject2, function (props) {
  return props.on ? props.onColor : props.offColor;
}, function (props) {
  return props.on ? 700 : 400;
});

var RightLabel = _styledComponents2.default.label(_templateObject3, function (props) {
  return props.on ? props.onColor : props.offColor;
}, function (props) {
  return props.on ? 700 : 400;
});

var CenterToggle = _styledComponents2.default.label(_templateObject4);

var MozartToggle = function (_Component) {
  _inherits(MozartToggle, _Component);

  function MozartToggle(props) {
    _classCallCheck(this, MozartToggle);

    var _this = _possibleConstructorReturn(this, (MozartToggle.__proto__ || Object.getPrototypeOf(MozartToggle)).call(this, props));

    _this.state = {
      switchValue: props.switchValue ? props.switchValue : false
    };
    return _this;
  }

  _createClass(MozartToggle, [{
    key: 'handleOnChange',
    value: function handleOnChange(switchValue) {
      var onChange = this.props.onChange;

      this.setState({
        switchValue: !switchValue
      });
      if (onChange) {
        onChange(switchValue);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          border = _props.border,
          style = _props.style,
          leftLabel = _props.leftLabel,
          rightLabel = _props.rightLabel,
          onColor = _props.onColor,
          offColor = _props.offColor,
          themeId = _props.themeId;
      var switchValue = this.state.switchValue;

      return _react2.default.createElement(
        ToggleContainer,
        { 'data-qa': this.props.testId, border: border, style: style, 'data-theme': themeId },
        _react2.default.createElement(
          LeftLabel,
          { onColor: onColor, offColor: offColor, on: !switchValue, className: 'leftLabel' },
          leftLabel
        ),
        _react2.default.createElement(
          CenterToggle,
          { className: 'centerToggle' },
          _react2.default.createElement('input', { type: 'checkbox', onChange: this.handleOnChange.bind(this, switchValue), checked: switchValue }),
          _react2.default.createElement('span', { className: 'slider round' })
        ),
        _react2.default.createElement(
          RightLabel,
          { onColor: onColor, offColor: offColor, on: switchValue, className: 'rightLabel' },
          rightLabel
        )
      );
    }
  }]);

  return MozartToggle;
}(_react.Component);

MozartToggle.propTypes = {
  /** qa attribute */
  testId: _propTypes2.default.string,
  /** theme attribute */
  themeId: _propTypes2.default.string,
  /** override style */
  style: _propTypes2.default.object,
  /** if true border of toggle */
  border: _propTypes2.default.bool,
  /** onChange callback when toggle */
  onChange: _propTypes2.default.func,
  /** left label */
  leftLabel: _propTypes2.default.string,
  /** right label */
  rightLabel: _propTypes2.default.string,
  /** default selection for toggle by default left is selected */
  switchValue: _propTypes2.default.bool,
  /** on mode color */
  onColor: _propTypes2.default.string,
  /** off mode color */
  offColor: _propTypes2.default.string
};
MozartToggle.defaultProps = {
  style: {},
  testId: 'MozartToggle',
  themeId: 'MozartToggle',
  offColor: _color2.default.blue_accent,
  onColor: _color2.default.blue_main
};
exports.default = MozartToggle;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Mozart/MozartToggle/MozartToggle.js
// module id = 2109
// module chunks = 1